import * as React from 'react';
import { IPortalPageSection } from 'models/portal/page/portalpagesection';
import { IUserPreferences } from 'models/user/userpreferences';
import * as c from 'models/constants';
import {
	PortalPageViewType11,
	PortalPageViewType12,
	PortalPageViewType2,
	PortalPageViewType3,
	PortalPageViewType4,
	PortalPageViewType5,
	PortalPageViewType6,
	PortalPageViewType7,
	PortalPageViewType8,
	PortalPageViewType9,
} from 'components/PortalPage/Sections';
import { UserFeed } from 'containers';

interface IProps {
	portalPageSection: IPortalPageSection;
	userPreferences?: IUserPreferences;
	baseUrlClient?: string;
	linkToMagazine?: string;
	isAdmin?: boolean;
}

class PortalPageSectionRenderer extends React.Component<IProps, any> {
	private getComponent(section: IPortalPageSection, linkToMagazine: string, isAdmin: boolean | undefined): JSX.Element {
		let component = null;
		const commonProps = {
			section,
			isAdmin,
		};
		switch (section.type) {
			//case c.PORTAL_PAGE_SECTION_TYPE_1:
			//  component = <PortalPageViewType1 section={portalPageSection} />;
			//  break;
			case c.PORTAL_PAGE_SECTION_TYPE_2:
				component = <PortalPageViewType2 {...commonProps} />;
				break;
			case c.PORTAL_PAGE_SECTION_TYPE_3:
				const { baseUrlClient, userPreferences } = this.props;
				component = (
					<PortalPageViewType3 {...commonProps} baseUrlClient={baseUrlClient} userPreferences={userPreferences} />
				);
				break;
			case c.PORTAL_PAGE_SECTION_TYPE_4:
				component = <PortalPageViewType4 {...commonProps} linkToMagazine={linkToMagazine} />;
				break;
			case c.PORTAL_PAGE_SECTION_TYPE_5:
				component = <PortalPageViewType5 {...commonProps} />;
				break;
			case c.PORTAL_PAGE_SECTION_TYPE_6:
				component = <PortalPageViewType6 {...commonProps} />;
				break;
			case c.PORTAL_PAGE_SECTION_TYPE_7:
				component = <PortalPageViewType7 {...commonProps} />;
				break;
			case c.PORTAL_PAGE_SECTION_TYPE_8:
				component = <PortalPageViewType8 {...commonProps} />;
				break;
			case c.PORTAL_PAGE_SECTION_TYPE_9:
				component = <PortalPageViewType9 {...commonProps} linkToMagazine={linkToMagazine} />;
				break;
			case c.PORTAL_PAGE_SECTION_TYPE_10:
				component = <UserFeed {...commonProps} />;
				break;
			case c.PORTAL_PAGE_SECTION_TYPE_11:
				component = <PortalPageViewType11 {...commonProps} />;
				break;
			case c.PORTAL_PAGE_SECTION_TYPE_12:
				component = <PortalPageViewType12 {...commonProps} />;
				break;
			default:
				component = null;
		}

		return component;
	}

	public render() {
		const { portalPageSection, linkToMagazine, isAdmin } = this.props;

		const component = this.getComponent(portalPageSection, linkToMagazine, isAdmin);

		return <div>{component}</div>;
	}
}

export { PortalPageSectionRenderer };
